import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import "../App.css";
import { connect } from "react-redux";
import {
  getMDDeatil,
  getOthersMI,
  getMDRelatedDocuments,
  getEuMI,
  getMDRemarks,
} from "../Actions/MDDetailAPI";
import { deleteMD } from "../Actions/MDDeleteAPI";
import { DownloadAttachment } from "../Actions/AttachmentAPI";
import Moment from "moment";
import swal from "sweetalert";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { css } from "glamor";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  getContractDeatil,
  getContractHistory,
  getContractSearchlist,
  getClientIMONO,
  getContractTypeOptions,
  getBillingTypeOptions,
  getPlanTypeOptions,
  getContractStatusOptions,
  getShipOptions,
} from "../Actions/ContractMgmtAPI";
import { getshipNameList } from "../Actions/UserManageAPI";
import { postContractAttachment } from "../Actions/CommonAPI";
import axios from "axios";
import API, { discountTypes } from "../helpers/api";
import { confirmAlert } from "react-confirm-alert";
import { deleteAttachmentInBucket } from "../Actions/CommonAPI";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import i18n from "./DropdownLanguage/i18n";
import Role from "../helpers/role";

toast.configure();
let user = localStorage.getItem("UserRoles");
let currentuser = JSON.parse(localStorage.getItem("currentUser"));

const SearchItem = {
  contractNumber: "",
  ShipName: "",
  ImoNo: "",
  clientName: "",
  startdate: "",
  expiryDate: "",
  minyear: "",
  maxyear: "",
  contractStatusId: 7,
  PageSize: 25,
  PageNumber: 1,
  overDue: false,
  dueIn30Days: false,
};

var fileDatas = [];

class EditContract extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEdit: false,
      StartDatePickerIsOpen: false,
      EndDatePickerIsOpen: false,
      submitDetails: false,
      disableShipName: false,
      // disableContractName: false,
      disableContractNumber: false,
      disableAttachment: false,
      disableStartDate: false,
      disableEndDate: false,
      disableStatus: false,
      buttonValue: "",
      shipName: {},
      searchDate: {
        contractId: "",
        shipId: "",
        // contractStatusId: "",
        status: 0,
        contractNumber: "",
        shipName: "",
        clientName: "",
        imoNumber: "",
        contractType: 0,
        planType: 0,
        billingPeriod: 0,
        attachmentName: "",
        amount: 0,
        attachmentGuid: "",
        startDate: "",
        endDate: "",
        comments: "",
        modifiedBy: currentuser.name,
        isDeleted: false,
        isExtraCharge: false,
        isExtraChargeApplicable: true,
        extraCharge: 0,
        isDiscountApplicable: false,
        discountType: "",
        discountValue: 0,
        isSurchargeIfz: false,
        surchargeIfz: "",
        surchargeIfztype: "",
      },
      isIfz: false,
      discountTypes: [],
      active: false,
      pending: false,
      terminated: false,
      contractDetail: null,
      prevStatus: "",
      disableSumCollected: false,
      disableContractType: false,
      disablePlanType: false,
      disableBillingPeriod: false,
    };

    this.startDatePicker = this.startDatePicker.bind(this);
    this.endDatePicker = this.endDatePicker.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    //    this.EditDetails = this.EditDetails.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.RenewContracts = this.RenewContracts.bind(this);
    this.EditContracts = this.EditContracts.bind(this);
    // this.deleteContracts = this.deleteContracts.bind(this);
    this.TerminateContracts = this.TerminateContracts.bind(this);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    this.getDiscountTypes();
    dispatch(getShipOptions());
    dispatch(getContractStatusOptions());
    dispatch(getContractTypeOptions());
    dispatch(getBillingTypeOptions());
    if (id) {
      dispatch(getContractDeatil(id));
      // dispatch(getContractHistory(id));
    }
    dispatch(getshipNameList());
  }

  getDiscountTypes = () => {
    let url = `${API.discountTypes}`;
    axios
      .get(url)
      .then((response) => {
        this.setState({ discountTypes: response.data });
        if (this.state.searchDate.discountType === "") {
          this.setState((prev) => ({
            searchDate: {
              ...prev.searchDate,
              discountType: "Percentage",
            },
          }));
        }
      })
      .catch((error) => {
        console.log("Error fetching discount types:", error);
      });
  };

  componentDidUpdate() {
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "ShowContractDetailsPane", data: false });
      this.props.history.push("/Home/Contracts");
      this.props.dispatch({ type: "ShowSidePan", data: false });
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      match,
      dispatch,
      contractAttachment,
      ClientIMONO,
      ContractDetail,
      shipListData,
    } = nextProps;
    const { params } = match;
    const { id } = params;
    if (contractAttachment) {
      prevState.searchDate.attachmentName = contractAttachment.FileName;
      prevState.searchDate.attachmentGuid = contractAttachment.Guid;
      dispatch({ type: "postContractAttachmentUploadSuccess", data: null });
    }
    if (ClientIMONO) {
      prevState.searchDate.clientName = ClientIMONO.clientName;
      prevState.searchDate.imoNumber = ClientIMONO.imo;
    }
    if (ContractDetail && ContractDetail !== "") {
      prevState.contractDetail = ContractDetail;
      prevState.searchDate.contractId = ContractDetail.contractId;
      prevState.searchDate.isExtraCharge =
        ContractDetail.isExtraCharge ?? false;
      prevState.searchDate.isExtraChargeApplicable =
        ContractDetail.isExtraChargeApplicable ?? false;
      prevState.searchDate.extraCharge = ContractDetail.extraCharge;
      prevState.searchDate.discountType =
        ContractDetail.discountType !== "" &&
        ContractDetail.discountType !== null
          ? ContractDetail.discountType
          : "Percentage";
      prevState.searchDate.discountValue = ContractDetail.discountValue ?? "";
      prevState.searchDate.isSurchargeIfz = ContractDetail.isSurchargeIfz
        ? true
        : false;
      prevState.isIfz = ContractDetail.contractType === "IFZ";
      prevState.searchDate.surchargeIfztype =
        ContractDetail.surchargeIfztype !== "" &&
        ContractDetail.surchargeIfztype !== null
          ? ContractDetail.surchargeIfztype
          : "Percentage";
      prevState.searchDate.surchargeIfz = ContractDetail.surchargeIfz ?? "";
      prevState.searchDate.isDiscountApplicable =
        ContractDetail.isDiscountApplicable ?? false;
      prevState.searchDate.shipId = ContractDetail.shipId;
      prevState.searchDate.status = ContractDetail.contractStatusId;
      // prevState.searchDate.contractName = ContractDetail.contractName;
      prevState.searchDate.contractNumber = ContractDetail.contractNumber;
      prevState.searchDate.shipId = ContractDetail.shipId;
      prevState.shipName = shipListData?.filter(
        (item) => item.lookUpId == ContractDetail.shipId
      )[0];
      prevState.searchDate.clientName = ContractDetail.clientName;
      prevState.searchDate.imoNumber = ContractDetail.imoNumber;
      prevState.searchDate.contractStatus = ContractDetail.contractStatus;
      prevState.searchDate.attachmentName = ContractDetail.attachmentName;
      prevState.searchDate.attachmentGuid = ContractDetail.attachmentGuid;
      prevState.searchDate.startDate = Moment(
        new Date(Date.parse(ContractDetail.startDate))
      ).format("YYYY-MM-DD");
      prevState.searchDate.endDate = Moment(
        new Date(Date.parse(ContractDetail.endDate))
      ).format("YYYY-MM-DD");
      prevState.prevStatus = ContractDetail.contractStatus;
      prevState.searchDate.contractType = ContractDetail.contractTypeId;
      prevState.searchDate.planType = ContractDetail.planTypeId;
      prevState.searchDate.billingPeriod = ContractDetail.billingPeriodId;
      prevState.searchDate.amount = ContractDetail.sumCollected;
      if (
        nextProps.PlanType?.length == 0 ||
        nextProps.PlanType == undefined ||
        nextProps.PlanType == null
      ) {
        dispatch(getPlanTypeOptions(parseInt(ContractDetail.contractTypeId)));
      }
      if (ContractDetail.contractStatus === "active") {
        prevState.active = true;
        prevState.pending = false;
        prevState.terminated = false;
        prevState.searchDate.contractStatus = "active";
      } else if (ContractDetail.contractStatus === "pending") {
        prevState.pending = true;
        prevState.active = false;
        prevState.terminated = false;
        prevState.searchDate.contractStatus = "pending";
      } else {
        prevState.terminated = true;
        prevState.active = false;
        prevState.pending = false;
        prevState.searchDate.contractStatus = "terminated";
      }
      dispatch({ type: "GetContractDetailSuccess", data: "" });
    }
  }

  ShowSidePanel = () => {
    this.props.dispatch({ type: "ShowContractDetailsPane", data: false });
    this.props.history.push("/Home/Contracts");
    this.props.dispatch({ type: "ShowSidePan", data: false });
  };

  MDNewitemNav = () => {
    this.props.dispatch({ type: "MD Library", data: false });
    this.props.history.push("/Home/MDNewItem");
  };

  handleStartDateChange(date) {
    this.state.searchDate.startDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      StartDatePickerIsOpen: false,
    });
  }

  handleEndDateChange(date) {
    this.state.searchDate.endDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      EndDatePickerIsOpen: false,
    });
  }

  handleInputChangeSum = (e) => {
    this.setState({
      searchDate: {
        ...this.state.searchDate,
        amount: parseInt(e.target.value),
      },
    });
  };

  startDatePicker() {
    this.setState({
      StartDatePickerIsOpen: !this.state.StartDatePickerIsOpen,
      EndDatePickerIsOpen: false,
    });
  }

  endDatePicker() {
    this.setState({
      StartDatePickerIsOpen: false,
      EndDatePickerIsOpen: !this.state.EndDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      StartDatePickerIsOpen: false,
      EndDatePickerIsOpen: false,
    });
  }

  handleRadioButtonChanges(e, item) {
    // let nodeName = e.target.name;
    this.state.searchDate["contractStatus"] = e.lookUpName;
    this.state.searchDate["status"] = e.lookUpId;
    this.setState({});
  }

  handleInputChange(e, value, name) {
    let nodeName = e.target.name;
    // if (nodeName === "contractStatusId") {
    //   this.state.searchDate[nodeName] = parseInt(e.target.value);
    // }
    // if (e.target.checked) {
    //   if (nodeName === "active") {
    //     this.state.searchDate.contractStatus = "active";
    //     this.setState({ active: e.target.checked });
    //   } else if (nodeName === "pending") {
    //     this.state.searchDate.contractStatus = "pending";
    //     this.setState({ pending: e.target.checked });
    //   } else if (nodeName === "terminated") {
    //     this.state.searchDate.contractStatus = "terminated";
    //     this.setState({ terminated: e.target.checked });
    //   }
    // }
    if (nodeName === "attachmentName") {
      let filename = e.target.files[0].name;
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        this.state.searchDate.attachmentName = e.target.files[0].name;
        this.props.dispatch(postContractAttachment(e.target.files[0]));
      } else {
        swal(
          "Error!",
          "Please upload the file without special characters.",
          "warning"
        );
        return;
      }
    } else if (name == "shipId") {
      this.props.dispatch(getClientIMONO(value?.lookUpName));
      this.state.searchDate[name] = value?.lookUpId;
      this.state.shipName = value;
    } else if (
      nodeName === "contractType" ||
      nodeName === "planType" ||
      nodeName === "billingPeriod"
    ) {
      if (nodeName === "contractType") {
        const selectedName = e.target.options[e.target.selectedIndex].text;
        this.state.isIfz = selectedName === "IFZ";
      }
      this.state.searchDate[nodeName] = parseInt(e.target.value);
    } else if (nodeName === "discountType") {
      if (e.target.value == "Percentage") {
        if (this.state.searchDate.discountValue > 100) {
          this.state.searchDate.discountValue = "";
        }
      }
      this.state.searchDate[nodeName] = e.target.value;
    } else if (nodeName === "surchargeIfztype") {
      if (e.target.value == "Percentage") {
        if (this.state.searchDate.surchargeIfz > 100) {
          this.state.searchDate.surchargeIfz = "";
        }
      }
      this.state.searchDate[nodeName] = e.target.value;
    } else {
      this.state.searchDate[nodeName] = e.target.value;
    }
    if (nodeName == "contractType") {
      this.state.searchDate["planType"] = 0;
      this.props.dispatch(getPlanTypeOptions(parseInt(e.target.value)));
    }
    this.setState({});
  }
  ClearInput() {
    //this.props.dispatch(deleteAttachmentInBucket(this.state.searchDate.attachmentGuid,this.state.searchDate.attachmentName));
    let obj = {
      filename: this.state.searchDate.attachmentName,
      guid: this.state.searchDate.attachmentGuid,
    };
    fileDatas.push(obj);
    this.state.searchDate.attachmentName = "";
    this.state.searchDate.attachmentGuid = "";
    this.setState({});
  }

  TerminateContracts() {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    this.state.searchDate.comments = "";
    this.state.searchDate.contractStatus = "terminated";
    if (this.state.searchDate.contractStatus === "terminated") {
      this.setState({
        terminated: true,
        active: false,
        pending: false,
      });
    }
    this.setState({
      submitDetails: true,
      showEdit: true,
      disableShipName: true,
      disableContractName: true,
      disableAttachment: true,
      disableStartDate: true,
      disableEndDate: true,
      disableStatus: true,
      StartDatePickerIsOpen: false,
      EndDatePickerIsOpen: false,
      buttonValue: "Terminate",
      disableSumCollected: true,
      disableContractType: true,
      disablePlanType: true,
      disableBillingPeriod: true,
    });
    console.log("terminate", this.state);
    //    dispatch(getContractDeatil(id));
  }
  EditContracts() {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    this.state.searchDate.comments = "";
    this.setState({
      submitDetails: true,
      showEdit: true,
      disableShipName: false,
      disableContractName: false,
      disableAttachment: false,
      disableStartDate: false,
      disableEndDate: false,
      disableStatus: false,
      StartDatePickerIsOpen: false,
      EndDatePickerIsOpen: false,
      buttonValue: "Edit",
      disableSumCollected: false,
      disableContractType: false,
      disablePlanType: false,
      disableBillingPeriod: false,
    });
    dispatch(getContractDeatil(id));
  }
  RenewContracts() {
    const { dispatch, match } = this.props;
    const { params } = match;
    const { id } = params;
    this.state.searchDate.comments = "";
    this.setState({
      submitDetails: true,
      showEdit: true,
      disableShipName: true,
      disableContractName: true,
      disableAttachment: false,
      disableStartDate: false,
      disableEndDate: false,
      disableStatus: true,
      StartDatePickerIsOpen: false,
      EndDatePickerIsOpen: false,
      buttonValue: "Renew",
      disableSumCollected: false,
      disableContractType: false,
      disablePlanType: false,
      disableBillingPeriod: false,
    });
    dispatch(getContractDeatil(id));
  }

  submitData() {
    const { dispatch, t } = this.props;
    const { searchDate } = this.state;
    let url = `${API.MMPLPostContractDetails}`;
    if (
      searchDate.shipId > 0 &&
      searchDate.startDate !== "" &&
      searchDate.endDate !== "" &&
      searchDate.contractType > 0 &&
      searchDate.planType > 0 &&
      searchDate.billingPeriod > 0 &&
      searchDate.contractNumber !== "" &&
      (!searchDate.isExtraCharge ||
        (searchDate.extraCharge !== 0 &&
          searchDate.extraCharge !== "" &&
          searchDate.extraCharge !== null)) &&
      (!searchDate.isDiscountApplicable ||
        (searchDate.discountValue !== 0 &&
          searchDate.discountValue !== "" &&
          searchDate.discountValue !== null)) &&
      (!searchDate.isSurchargeIfz ||
        !this.state.isIfz ||
        (searchDate.surchargeIfz !== 0 &&
          searchDate.surchargeIfz !== "" &&
          searchDate.surchargeIfz !== null))
    ) {
      let apiData = {
        ...this.state.searchDate,
        extraCharge: this.state.searchDate.isExtraCharge
          ? this.state.searchDate.extraCharge
          : 0,
        discountType: this.state.searchDate.isDiscountApplicable
          ? this.state.searchDate.discountType
          : null,
        discountValue: this.state.searchDate.isDiscountApplicable
          ? this.state.searchDate.discountValue
          : null,
        isSurchargeIfz:
          this.state.searchDate.isSurchargeIfz && this.state.isIfz
            ? this.state.searchDate.isSurchargeIfz
            : false,
        surchargeIfztype:
          this.state.searchDate.isSurchargeIfz && this.state.isIfz
            ? this.state.searchDate.surchargeIfztype
            : null,
        surchargeIfz:
          this.state.searchDate.isSurchargeIfz && this.state.isIfz
            ? parseInt(this.state.searchDate.surchargeIfz)
            : null,
      };
      axios
        .post(url, apiData)
        .then((response) => {
          if (response.data == true) {
            if (fileDatas.length > 0) {
              this.props.dispatch(deleteAttachmentInBucket(fileDatas));
              fileDatas = [];
            }
            dispatch(getContractSearchlist(SearchItem));
            this.ShowSidePanel();
            toast.success(`${t("CommonText.CommonUpdate")}`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            dispatch({
              type: "PutContractDetailSuccess",
              data: response.data,
            });
          } else {
            swal(
              "Error!",
              `${t("ContractManagementContent.activeContractError")}`,
              "warning"
            );
          }
        })
        .catch((error) => {
          dispatch({
            type: "PutContractDetailFailure",
            error: "ERROR",
          });
        });
    } else {
      swal(
        "Error!",
        `${t("ContractManagementContent.MandatoryWarningMsg")}`,
        "warning"
      );
    }
  }

  // deleteContracts() {
  //   const { dispatch, t } = this.props;
  //   console.log(t("confirmAlertMessage.DeleteMsg"))
  //   confirmAlert({
  //     message: `${t("confirmAlertMessage.DeleteMsg")}`,
  //     buttons: [
  //       {
  //         label: `${t("confirmAlertMessage.Yes")}`,
  //         onClick: () => {
  //           // let user = {
  //           //   contractId: this.state.searchDate.contractId,
  //           //   shipId: this.state.searchDate.shipId,
  //           //   contractStatusId: this.state.searchDate.contractStatusId,
  //           //   shipName: this.state.searchDate.shipName,
  //           //   contractName: this.state.searchDate.contractName,
  //           //   clientName: this.state.searchDate.clientName,
  //           //   imoNumber: this.state.searchDate.imoNumber,
  //           //   contractStatus: this.state.searchDate.contractStatus,
  //           //   startDate: this.state.searchDate.startDate,
  //           //   endDate: this.state.searchDate.endDate,
  //           //   comments: this.state.searchDate.comments,
  //           //   modifiedBy: this.state.searchDate.modifiedBy,
  //           //   isDeleted: true,
  //           // };
  //           let contractData = {
  //             "contractId": this.state.searchDate.contractId,
  //             "terminateContract": false,
  //             "deleteContract": true,
  //             "actionBy": this.state.searchDate.modifiedBy
  //           }
  //           let url = `${API.MMPLStatusContractDetails}`;
  //           axios
  //             .put(url, contractData)
  //             .then((response) => {
  //               dispatch(getContractSearchlist(SearchItem));
  //               this.ShowSidePanel();
  //               toast.success(`${t("confirmAlertMessage.DeleteMsg")}`, {
  //                 position: "top-right",
  //                 autoClose: 5000,
  //                 hideProgressBar: true,
  //                 closeOnClick: true,
  //                 pauseOnHover: true,
  //                 draggable: true,
  //                 progress: undefined,
  //               });
  //               dispatch({
  //                 type: "DeleteContractDetailSuccess",
  //                 data: response.data,
  //               });
  //             })
  //             .catch((error) => {
  //               dispatch({
  //                 type: "DeleteContractDetailFailure",
  //                 error: "ERROR",
  //               });
  //             });
  //         },
  //       },
  //       {
  //         label: `${t("confirmAlertMessage.No")}`,
  //         onClick: () => { },
  //       },
  //     ],
  //   });
  // }

  cancel() {
    fileDatas = [];
    this.setState({
      submitDetails: false,
      showEdit: false,
    });
  }
  downloadContract(Filename, Guid) {
    this.props.dispatch(DownloadAttachment(Filename, Guid));
  }

  terminateOrDeleteContract = (key) => {
    const { match, t } = this.props;
    const { params } = match;
    const { id } = params;
    let url = `${API.MMPLStatusContractDetails}`;
    // let meta = {
    //   contractId: id,
    //   terminateContract: key == "TERMINATE",
    //   deleteContract: key == "DELETE"
    // }
    let contractData = {
      contractId: this.state.searchDate.contractId,
      terminateContract: key == "TERMINATE" ? true : false,
      deleteContract: key == "DELETE" ? true : false,
      actionBy: this.state.searchDate.modifiedBy,
    };
    axios
      .put(url, contractData)
      .then((response) => {
        this.props.history.push("/Home/Contracts");
        this.props.dispatch(getContractSearchlist(SearchItem));
        this.ShowSidePanel();
        toast.success(
          `${
            key == "DELETE"
              ? t("confirmAlertMessage.DeletedSuccessMessage")
              : t("confirmAlertMessage.TerminateSuccessMessage")
          }`,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };

  render() {
    const {
      mdDetailList,
      MIOthersList,
      MIEuList,
      RemarksList,
      contractHistory,
      shipNameList,
      t,
    } = this.props;
    const { contractDetail } = this.state;
    const isArabic = i18n.language === "arab";
    return (
      <div className="row py-1">
        <div className="full-height pt-3">
          <div className="panel-box  search-filter-box mb-4">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.ShowSidePanel()}
              style={{ display: "inline-flex", alignItems: "center" }}
            >
              <span style={{ marginTop: "-1px" }}>&larr;</span>
              {t("CommonText.Return")}
            </button>

            <div className="resource-list-auth-date">
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    {t("ContractManagementContent.ContractDetails")}
                  </h5>
                </div>
                <div className="search-filter-box">
                  <div className="row mt-2">
                    {this.state.showEdit ? (
                      <>
                        <div className="col-lg-6">
                          <label className="form-label required">
                            {t("ContractContent.ContractNumber")}
                          </label>
                          <br></br>
                          <input
                            className="form-control"
                            name="contractNumber"
                            value={this.state.searchDate.contractNumber}
                            onChange={(e) => this.handleInputChange(e)}
                            disabled={this.state.disableContractNumber}
                          ></input>
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label required">
                            {t("content.Shipname")}
                          </label>
                          <br></br>
                          <Autocomplete
                            style={{ marginTop: "-18px" }}
                            name="shipId"
                            noOptionsText={`${t("CommonText.NoOption")}`}
                            size={"small"}
                            value={this.state.shipName}
                            onChange={(e, value) =>
                              this.handleInputChange(e, value, "shipId")
                            }
                            getOptionLabel={(item) => item.lookUpName || ""}
                            options={this.props.shipListData ?? []}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={t(
                                  "ContractManagementContent.SelectShip"
                                )}
                                margin="normal"
                              />
                            )}
                          />
                          {/* <select
                            className="form-control"
                            name="shipName"
                            value={this.state.searchDate.shipName}
                            onChange={(e) => this.handleInputChange(e)}
                            disabled={this.state.disableShipName}
                          >
                            <option value="">
                              {t("ContractManagementContent.SelectShipname")}
                            </option>
                            {shipNameList &&
                              shipNameList.map((ships) => (
                                <option value={ships}>{ships}</option>
                              ))}
                          </select> */}
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">
                            {" "}
                            {t("ContractManagementContent.IMONumber")}
                          </label>
                          <br></br>
                          <input
                            className="form-control"
                            name="imoNumber"
                            value={this.state.searchDate.imoNumber}
                            onChange={(e) => this.handleInputChange(e)}
                            readOnly
                          ></input>
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label">
                            {t("ContractManagementContent.ClientName")}
                          </label>
                          <br></br>
                          <input
                            className="form-control"
                            name="clientName"
                            value={this.state.searchDate.clientName}
                            onChange={(e) => this.handleInputChange(e)}
                            readOnly
                          ></input>
                        </div>
                        {/* <div className="col-lg-12">
                          <label className="form-label">
                            {t("EquipmentServiceTypes.Status")}
                          </label>
                          <br></br>
                          <div className="row">
                            {this.props.contractStatus?.map((item, ind) => (
                              item.lookUpName &&
                              <div className={"col-lg-4"}>
                                <input
                                  type="radio"
                                  name={item.lookUpName}
                                  checked={
                                    this.state.searchDate.status === item.lookUpId
                                  }
                                  onChange={this.handleRadioButtonChanges.bind(this, item)}
                                ></input>
                                <span className="ml-1 text-capitalize">{item.lookUpName}</span>
                              </div>
                            ))}
                            {/* <div className="col-lg-4">
                              <input
                                type="radio"
                                name="active"
                                checked={
                                  this.state.searchDate.contractStatus ===
                                  "active"
                                }
                                disabled={this.state.disableStatus}
                                onChange={(e) =>
                                  this.handleRadioButtonChanges(e)
                                }
                              ></input>
                              <span className="ml-1">
                                {t("ShipManagementContent.Active")}
                              </span>
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="radio"
                                name="pending"
                                checked={
                                  this.state.searchDate.contractStatus ===
                                  "pending"
                                }
                                disabled={this.state.disableStatus}
                                onChange={(e) =>
                                  this.handleRadioButtonChanges(e)
                                }
                              ></input>
                              <span className="ml-1">
                                {t("ShipManagementContent.Pending")}
                              </span>
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="radio"
                                name="terminated"
                                checked={
                                  this.state.searchDate.contractStatus ===
                                  "terminated"
                                }
                                disabled={this.state.disableStatus}
                                onChange={(e) =>
                                  this.handleRadioButtonChanges(e)
                                }
                              ></input>
                              <span className="ml-1">
                                {t("ShipManagementContent.Terminated")}
                              </span>
                            </div> *
                          </div>
                        </div> */}

                        <div className="col-lg-6">
                          <label className="form-label required">
                            {t("ContractManagementContent.StartDate")}
                          </label>
                          <br></br>
                          <div
                            className="input-group add-on date datepicker"
                            data-date-format="dd-mm-yyyy"
                          >
                            <input
                              type="text"
                              className="form-control date-picker"
                              placeholder={t(
                                "ContractManagementContent.StartDate"
                              )}
                              name="startDate"
                              value={Moment(
                                new Date(
                                  Date.parse(this.state.searchDate.startDate)
                                )
                              ).format("DD-MM-YYYY")}
                              disabled={this.state.disableStartDate}
                            ></input>
                            <DatePicker
                              maxDate={new Date(this.state.searchDate.endDate)}
                              onChange={this.handleStartDateChange}
                              open={this.state.StartDatePickerIsOpen}
                              onClickOutside={this.handleBlur}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              disabled={this.state.disableStartDate}
                              className="form-control date-picker w-5 hide-date"
                            />
                            <div
                              className="input-group-btn calendar-icon"
                              onClick={this.startDatePicker}
                            >
                              <button className="btn btn-default">
                                <i className="fa fa-calendar mt-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label required">
                            {t("ContractManagementContent.EndDate")}
                          </label>
                          <br></br>
                          <div
                            className="input-group add-on date datepicker"
                            data-date-format="dd-mm-yyyy"
                          >
                            <input
                              type="text"
                              className="form-control date-picker"
                              placeholder={t(
                                "ContractManagementContent.EndDate"
                              )}
                              name="endDate"
                              value={Moment(
                                new Date(
                                  Date.parse(this.state.searchDate.endDate)
                                )
                              ).format("DD-MM-YYYY")}
                              disabled={this.state.disableEndDate}
                            ></input>
                            <DatePicker
                              minDate={
                                new Date(this.state.searchDate.startDate)
                              }
                              onChange={this.handleEndDateChange}
                              open={this.state.EndDatePickerIsOpen}
                              onClickOutside={this.handleBlur}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              popperPlacement="top-end"
                              disabled={this.state.disableEndDate}
                              className="form-control date-picker w-5 hide-date"
                            />
                            <div
                              className="input-group-btn calendar-icon"
                              onClick={this.endDatePicker}
                            >
                              <button className="btn btn-default">
                                <i className="fa fa-calendar mt-1"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className={"col-lg-12"}>
                          <label className="form-label">
                            {t("ShipEquipmentStatusScreen.ContractAttachment")}
                          </label>
                          <br></br>
                          <div class="input-group mb-3">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                {t("CommonText.BrowseFile")}
                                <input
                                  type="file"
                                  id="files"
                                  name="attachmentName"
                                  style={{ marginRight: 40 }}
                                  onChange={(e) => this.handleInputChange(e)}
                                  disabled={this.state.disableAttachment}
                                />
                              </span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              placeholder=""
                              value={this.state.searchDate.attachmentName}
                              disabled={this.state.disableAttachment}
                            />
                            {this.state.searchDate.attachmentName ? (
                              <div
                                class="input-group-append"
                                style={{ cursor: "pointer" }}
                              >
                                <i
                                  class="fa fa-times input-group-text"
                                  aria-hidden="true"
                                  onClick={() => this.ClearInput()}
                                ></i>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">
                            {t("ContractContent.SumCollected")}
                          </label>
                          <br></br>
                          <div className="input-group">
                            <input
                              className="form-control"
                              type="number"
                              name="sumCollected"
                              placeholder={t("ContractContent.SumCollected")}
                              onChange={(e) => this.handleInputChangeSum(e)}
                              value={this.state.searchDate.amount}
                              disabled={this.state.disableSumCollected}
                            ></input>
                            <div className="input-group-append">
                              <span className="input-group-text">USD</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label required">
                            {t("ShipEquipmentStatusScreen.ContractType")}
                          </label>
                          <br></br>
                          <select
                            className="form-control"
                            name="contractType"
                            id="contractType"
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchDate.contractType}
                            disabled={this.state.disableContractType}
                          >
                            <option value="">
                              {t("ShipManagementContent.SelectContractType")}
                            </option>
                            {this.props.ContractType?.map((item) => (
                              <option value={item.lookUpId}>
                                {item.lookUpName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label required">
                            {t("ShipEquipmentStatusScreen.PlanType")}
                          </label>
                          <br></br>
                          <select
                            className="form-control"
                            name="planType"
                            id="planType"
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchDate.planType}
                            disabled={this.state.disablePlanType}
                          >
                            <option value="">
                              {t("ShipManagementContent.SelectPlanType")}
                            </option>
                            {this.props.PlanType?.map((item) => (
                              <option value={item.lookUpId}>
                                {item.lookUpName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-6">
                          <label className="form-label required">
                            {t("ContractContent.BillingPeriod")}
                          </label>
                          <br></br>
                          <select
                            className="form-control"
                            name="billingPeriod"
                            id="billingPeriod"
                            onChange={(e) => this.handleInputChange(e)}
                            value={this.state.searchDate.billingPeriod}
                            disabled={this.state.disableBillingPeriod}
                          >
                            <option value="">
                              {t("ContractContent.SelectBillingPeriod")}
                            </option>
                            {this.props.BillingType?.map((item) => (
                              <option value={item.lookUpId}>
                                {item.lookUpName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className={"col-lg-6 "}>
                          <div className="d-flex align-items-center mt-4 mt-lg-4 mt-md-2 mt-sm-1">
                            <input
                              type="checkbox"
                              className="checkbox-style"
                              checked={this.state.searchDate.isExtraCharge}
                              onChange={(event) =>
                                this.setState({
                                  searchDate: {
                                    ...this.state.searchDate,
                                    isExtraCharge: event.target.checked,
                                  },
                                })
                              }
                            />
                            <label className="form-label ml-2">
                              {t("ShipDetailsScreen.IsAdditionApplicable")}
                            </label>
                          </div>
                        </div>
                        {this.state.searchDate.isExtraCharge && (
                          <div className={"col-lg-6 "}>
                            <label className="form-label required">
                              {t("ShipDetailsScreen.AdditionalCharge")}
                            </label>
                            <br></br>
                            <div className="input-group">
                              <input
                                className="form-control"
                                type="number"
                                name="extraCharge"
                                placeholder={t(
                                  "ShipDetailsScreen.AdditionalCharge"
                                )}
                                onChange={(e) => this.handleInputChange(e)}
                                value={this.state.searchDate.extraCharge}
                              />
                              <div className="input-group-append">
                                <span className="input-group-text">USD</span>
                              </div>
                            </div>
                          </div>
                        )}
                        {!this.state.searchDate.isExtraCharge && (
                          <div className={"col-lg-6 v-none"}></div>
                        )}
                        <div className={` col-lg-6`}>
                          {/* <label className="form-label v-none">
                            Is Discount Applicable
                          </label> */}
                          <br></br>
                          <div className="d-flex align-items-center">
                            <input
                              type="checkbox"
                              className="checkbox-style"
                              checked={
                                this.state.searchDate.isDiscountApplicable
                              }
                              onChange={(event) =>
                                this.setState({
                                  searchDate: {
                                    ...this.state.searchDate,
                                    isDiscountApplicable: event.target.checked,
                                  },
                                })
                              }
                            />
                            <label className="form-label ml-2">
                              {/* Is Discount Applicable */}
                              {t("ShipDetailsScreen.isDiscountApplicable")}
                            </label>
                          </div>
                        </div>
                        {this.state.searchDate.isDiscountApplicable && (
                          <div className={`col-lg-6`}>
                            <label className="form-label required">
                              {t("ShipDetailsScreen.Discount")}
                            </label>
                            <br></br>
                            <div className="input-group">
                              <input
                                className="form-control"
                                type="number"
                                name="discountAmount"
                                placeholder={t("ShipDetailsScreen.Discount")}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  const discountType =
                                    this.state.searchDate.discountType;
                                  if (value.trim() !== "") {
                                    const isValidPercentage =
                                      /^(100(\.0{1,2})?|([1-9]?\d)(\.\d{1,2})?)$/.test(
                                        value
                                      ) && !/^100\.$/.test(value);

                                    if (
                                      discountType === "Percentage" &&
                                      !isValidPercentage
                                    )
                                      return;

                                    this.handleInputChange({
                                      target: {
                                        name: "discountValue",
                                        value,
                                      },
                                    });
                                  } else {
                                    this.handleInputChange({
                                      target: {
                                        name: "discountValue",
                                        value,
                                      },
                                    });
                                  }
                                }}
                                value={this.state.searchDate.discountValue}
                              />
                              <div className="input-group-append">
                                <select
                                  className="form-select input-group-text"
                                  value={this.state.searchDate.discountType}
                                  name="discountType"
                                  onChange={(e) => this.handleInputChange(e)}
                                >
                                  {this.state.discountTypes.map((type) => (
                                    <option key={type} value={type}>
                                      {type == "Percentage" ? "%" : "USD"}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        )}
                        {!this.state.searchDate.isDiscountApplicable && (
                          <div className={"col-lg-6 v-none"}></div>
                        )}
                        {this.state.isIfz && (
                          <div className={` col-lg-6`}>
                            {/* <label className="form-label v-none">
                            Is Discount Applicable
                          </label> */}
                            <br></br>
                            <div className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                className="checkbox-style"
                                checked={this.state.searchDate.isSurchargeIfz}
                                onChange={(event) =>
                                  this.setState({
                                    searchDate: {
                                      ...this.state.searchDate,
                                      isSurchargeIfz: event.target.checked,
                                    },
                                  })
                                }
                              />
                              <label className="form-label ml-2">
                                {/* Is Discount Applicable */}
                                Is Surcharge Applicable for IFZ
                              </label>
                            </div>
                          </div>
                        )}
                        {this.state.searchDate.isSurchargeIfz &&
                          this.state.isIfz && (
                            <div className={`col-lg-6`}>
                              <label className="form-label required">
                                {"Surcharge"}
                              </label>
                              <br></br>
                              <div className="input-group">
                                <input
                                  className="form-control"
                                  type="number"
                                  name="discountAmount"
                                  placeholder={"Surcharge"}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const discountType =
                                      this.state.searchDate.surchargeIfztype;
                                    if (value.trim() !== "") {
                                      const isValidPercentage =
                                        /^(100(\.0{1,2})?|([1-9]?\d)(\.\d{1,2})?)$/.test(
                                          value
                                        ) && !/^100\.$/.test(value);

                                      if (
                                        discountType === "Percentage" &&
                                        !isValidPercentage
                                      )
                                        return;

                                      this.handleInputChange({
                                        target: {
                                          name: "surchargeIfz",
                                          value,
                                        },
                                      });
                                    } else {
                                      this.handleInputChange({
                                        target: {
                                          name: "surchargeIfz",
                                          value,
                                        },
                                      });
                                    }
                                  }}
                                  value={this.state.searchDate.surchargeIfz}
                                />
                                <div className="input-group-append">
                                  <select
                                    className="form-select input-group-text"
                                    value={
                                      this.state.searchDate.surchargeIfztype
                                    }
                                    name="surchargeIfztype"
                                    onChange={(e) => this.handleInputChange(e)}
                                  >
                                    {this.state.discountTypes.map((type) => (
                                      <option key={type} value={type}>
                                        {type == "Percentage" ? "%" : "USD"}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          )}
                        <div className={"col-lg-12 "}>
                          <div className="d-flex align-items-center mt-3 mt-lg-3 mt-md-2 mt-sm-2">
                            <input
                              type="checkbox"
                              className="checkbox-style"
                              checked={this.state.searchDate.isExtraChargeApplicable}
                              onChange={(event) =>
                                this.setState({
                                  searchDate: {
                                    ...this.state.searchDate,
                                    isExtraChargeApplicable: event.target.checked,
                                  },
                                })
                              }
                            />
                            <label className="form-label ml-2">
                              Is Extra Charges Applicable
                              {/* {t("ShipDetailsScreen.IsAdditionApplicable")} */}
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <label className="form-label">
                            {t("ShipDetailsScreen.Comments")}
                          </label>
                          <br></br>
                          <textarea
                            className="form-control"
                            name="comments"
                            value={this.state.searchDate.comments}
                            onChange={(e) => this.handleInputChange(e)}
                          ></textarea>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("content.Shipname")}: </strong>
                            <span>
                              {contractDetail ? contractDetail.shipName : ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>
                              {t("ContractContent.ContractNumber")}:{" "}
                            </strong>
                            <span>
                              {contractDetail
                                ? contractDetail.contractNumber
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>
                              {t("ContractManagementContent.IMONumber")}:{" "}
                            </strong>
                            <span>
                              {contractDetail ? contractDetail.imoNumber : ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>
                              {t("ContractManagementContent.ClientName")}:{" "}
                            </strong>
                            <span>
                              {contractDetail ? contractDetail.clientName : ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span className={`${isArabic ? "arabic_ship" : ""}`}>
                            <strong>
                              {t("ContractManagementContent.StartDate")}
                            </strong>
                            <strong>:</strong>{" "}
                          </span>
                          <span>
                            {contractDetail
                              ? moment(contractDetail.startDate).format(
                                  "DD MMM YYYY"
                                )
                              : ""}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span className={`${isArabic ? "arabic_ship" : ""}`}>
                            <strong>
                              {t("ContractManagementContent.ExpiryDate")}
                            </strong>
                            <strong>:</strong>{" "}
                          </span>
                          <span>
                            {contractDetail
                              ? moment(contractDetail.endDate).format(
                                  "DD MMM YYYY"
                                )
                              : ""}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>
                              {t("ShipManagementContent.ContractStatus")}:{" "}
                            </strong>
                            <span className="text-capitalize">
                              {contractDetail
                                ? contractDetail.contractStatus
                                : ""}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>
                              {t(
                                "ShipEquipmentStatusScreen.ContractAttachment"
                              )}
                              :{" "}
                            </strong>
                            <span>
                              {contractDetail
                                ? contractDetail.attachmentName
                                : ""}
                            </span>
                            {contractDetail && contractDetail.attachmentName ? (
                              <i
                                className="fa fa-download ml-1 fa-lg click"
                                style={{ width: 20, height: 20 }}
                                onClick={() =>
                                  this.downloadContract(
                                    contractDetail.attachmentName,
                                    contractDetail.attachmentGuid
                                  )
                                }
                              ></i>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span className={`${isArabic ? "arabic" : ""}`}>
                            <strong>
                              {t("ContractContent.SumCollected")}
                            </strong>
                            <strong>:</strong>{" "}
                            <span className="text-capitalize">
                              {contractDetail
                                ? contractDetail.sumCollected
                                : ""}
                            </span>
                          </span>
                        </div>
                        {user === Role.mmpladmin &&
                          contractDetail?.isExtraCharge && (
                            <div className="col-sm-6 mb-2">
                              <span className={`${isArabic ? "arabic" : ""}`}>
                                <strong>
                                  {t("ShipDetailsScreen.AdditionalCharge")}
                                </strong>
                                <strong>:</strong>{" "}
                                <span className="text-capitalize">
                                  {contractDetail
                                    ? contractDetail.extraCharge ?? ""
                                    : ""}
                                </span>
                              </span>
                            </div>
                          )}
                        {user === Role.mmpladmin &&
                          contractDetail?.isDiscountApplicable && (
                            <div className="col-sm-6 mb-2">
                              <span className={`${isArabic ? "arabic" : ""}`}>
                                {/* <strong>{t("ShipDetailsScreen.AdditionalCharge")}  </strong> */}
                                <strong>
                                  {t("ShipDetailsScreen.Discount")}
                                </strong>
                                <strong>:</strong>{" "}
                                <span className="text-capitalize">
                                  {contractDetail
                                    ? contractDetail.discountValue ?? ""
                                    : ""}
                                  {contractDetail
                                    ? contractDetail.discountType ==
                                      "Percentage"
                                      ? "%"
                                      : ""
                                    : ""}
                                </span>
                              </span>
                            </div>
                          )}
                        {user === Role.mmpladmin &&
                          contractDetail?.isSurchargeIfz &&
                          contractDetail.contractType == "IFZ" && (
                            <div className="col-sm-6 mb-2">
                              <span className={`${isArabic ? "arabic" : ""}`}>
                                {/* <strong>{t("ShipDetailsScreen.AdditionalCharge")}  </strong> */}
                                <strong>Surcharge:</strong>{" "}
                                <span className="text-capitalize">
                                  {contractDetail
                                    ? contractDetail.surchargeIfz ?? ""
                                    : ""}
                                  {contractDetail
                                    ? contractDetail.surchargeIfztype ==
                                      "Percentage"
                                      ? "%"
                                      : ""
                                    : ""}
                                </span>
                              </span>
                            </div>
                          )}
                        {user === Role.mmpladmin && (
                          <div className="col-sm-6 mb-2">
                            <span className={`${isArabic ? "arabic" : ""}`}>
                              {/* <strong>{t("ShipDetailsScreen.AdditionalCharge")}  </strong> */}
                              <strong>
                                {/* {t("ShipDetailsScreen.Discount")}{" "} */}
                                Extra Charges Applicable
                              </strong>
                              <strong>:</strong>{" "}
                              <span className="text-capitalize">
                                {contractDetail?.isExtraChargeApplicable ? "Yes" : "No"}
                              </span>
                            </span>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  {this.state.submitDetails ? (
                    <div className="row">
                      <div className={"col-lg-12 mt-4 mb-3"}>
                        <div
                          className=" search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.submitData()}
                          >
                            {" "}
                            {t("ComplianceandBudgetScreen.Submit")}{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.cancel()}
                          >
                            {" "}
                            {t("ComplianceandBudgetScreen.Cancel")}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-md-12 col-12 col-sm-12 col-m-auto mt-1">
                        <div
                          className="search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          {/* <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn"
                            type="button"
                            onClick={() => this.RenewContracts()}
                          >
                            {" "}
                            {t("ContractManagementContent.Renew")}{" "}
                          </button> */}
                          {user === Role.mmpladmin && (
                            <>
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-1"
                                type="submit"
                                onClick={() => this.EditContracts()}
                              >
                                {" "}
                                {t("IntervelScreen.Edit")}{" "}
                              </button>
                              <button
                                className="btn btn-danger text-uppercase txtside-btn txtht-btn blue"
                                type="submit"
                                // onClick={() => this.TerminateContracts()}
                                onClick={() =>
                                  this.terminateOrDeleteContract("TERMINATE")
                                }
                              >
                                {" "}
                                {t("ContractManagementContent.Terminate")}{" "}
                              </button>
                              <button
                                className="btn btn-danger text-uppercase txtside-btn txtht-btn blue m-1"
                                type="submit"
                                // onClick={() => this.deleteContracts()}
                                onClick={() =>
                                  this.terminateOrDeleteContract("DELETE")
                                }
                              >
                                {" "}
                                {t("CommonText.Delete")}{" "}
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* <div className="card-body">
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    {t("ContractManagementContent.ContractHistory")}
                  </h5>
                </div>
                <div className="search-filter-box">
                  {this.renderHistoryCard()}
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderHistoryCard() {
    const { contractHistory, t } = this.props;
    return contractHistory && contractHistory.length
      ? contractHistory.map((item, index) => {
          return (
            <>
              {item && item.contractId !== 0 ? (
                <div
                  className="card MM-card-content mb-2"
                  style={{
                    backgroundColor: "#f0f0f0",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <div className="p-3">
                    <div className="resource-list-auth-date">
                      <div className="row">
                        <div className="col-sm-12 my-1">
                          <span>
                            <strong>{t("content.Shipname")}: </strong>
                            <span className="italicFont ">{item.shipName}</span>
                          </span>
                        </div>
                        <div className="col-sm-6 my-1">
                          <span>
                            <strong>
                              {t("ShipManagementContent.ContractNumber")}:{" "}
                            </strong>
                            <span className="italicFont ">
                              {" "}
                              {item.contractNumber}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-6 my-1">
                          <span>
                            <strong>
                              {t("ContractManagementContent.ClientName")}:{" "}
                            </strong>
                            <span className="italicFont ">
                              {" "}
                              {item.clientName}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-6 my-1">
                          <span>
                            <strong>{t("content.IMOno")}: </strong>
                            <span className="italicFont ">
                              {" "}
                              {item.imoNumber}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-6 my-1">
                          <span>
                            <strong>
                              {t("ContractManagementContent.StartDate")}:{" "}
                            </strong>
                            <span className="italicFont ">
                              {" "}
                              {moment(item.startDate).format("DD MMM YYYY")}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-6 my-1">
                          <span>
                            <strong>
                              {t("ContractManagementContent.ExpiryDate")}:{" "}
                            </strong>
                            <span className="italicFont ">
                              {" "}
                              {moment(item.endDate).format("DD MMM YYYY")}
                            </span>
                          </span>
                        </div>
                        <div className="col-sm-12 my-1">
                          <span>
                            <strong>
                              {t("ContractManagementContent.DownloadContract")}:{" "}
                            </strong>
                            <span className="italicFont ">
                              {item.attachmentName}
                            </span>
                            {item && item.attachmentName ? (
                              <i
                                className="fa fa-download ml-1 fa-lg click"
                                style={{ width: 20, height: 20 }}
                                onClick={() =>
                                  this.downloadContract(
                                    item.attachmentName,
                                    item.attachmentGuid
                                  )
                                }
                              ></i>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </>
          );
        })
      : null;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    mdDetailList: state.SidePanReducer.mdDetailList
      ? state.SidePanReducer.mdDetailList
      : "",
    MIOthersList: state.SidePanReducer.MIOthersList,
    MIEuList: state.SidePanReducer.MIEuList,
    RDList: state.SidePanReducer.RDList,
    RemarksList: state.SidePanReducer.RemarksList,
    //BY BALU MOORTHI
    ContractDetail: state.ContractMgmtReducer.ContractDetail,
    contractHistory: state.ContractMgmtReducer.ContractHistory || [],
    shipNameList: state.UserManagerReducer.shipNameList || [],
    ClientIMONO: state.ContractMgmtReducer.ClientIMONO,
    contractAttachment: state.ContractMgmtReducer.contractAttachment,
    ContractType: state.ContractMgmtReducer.ContractType,
    PlanType: state.ContractMgmtReducer.PlanType,
    BillingType: state.ContractMgmtReducer.BillingType,
    contractStatus: state.ContractMgmtReducer.contractStatus,
    shipListData: state.ContractMgmtReducer.shipListData,
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(EditContract)
);
